import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { GRAPH_NODE_DISPLAY_TEXT } from '@src/constants/MogamboConstants';

import Label from '../Label';

function Node({
  active,
  type,
  disabled,
  color,
  onClick,
  onDragStart,
  onDragEnd,
  contextMenu,
  title,
  customCSS,
  draggable,
  closeAddSkillDrawer,
}) {
  let nodeDom = null;

  useEffect(() => {
    if (nodeDom && active) {
      const ref = nodeDom;
      setTimeout(() => {
        ref.scrollIntoViewIfNeeded(true);
      }, 1000);
    }
  }, [active]);

  const labelProps = {
    active,
    disabled,
    type,
    color: color?.primary,
    onClick,
    onDragStart,
    onDragEnd,
    contextMenuItems: contextMenu,
    small: true,
    draggable,
    innerRef: (ref) => {
      nodeDom = ref;
    },
    customCSS,
    closeAddSkillDrawer,
  };

  return <Label {...labelProps}>{title}</Label>;
}

Node.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  draggable: PropTypes.bool,
  customCSS: PropTypes.bool,
  onClick: PropTypes.func,
  onDragStart: PropTypes.func,
  onDragEnd: PropTypes.func,
  type: PropTypes.string,
  contextMenu: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
  color: PropTypes.shape({
    primary: PropTypes.string,
  }),
};

Node.defaultProps = {
  active: false,
  disabled: false,
  customCSS: false,
  draggable: true,
  onClick: () => {},
  onDragStart: () => {},
  onDragEnd: () => {},
  contextMenu: [],
  type: GRAPH_NODE_DISPLAY_TEXT.STATIC,
  title: '',
  color: {
    primary: '',
  },
};

export default Node;
